import { render, staticRenderFns } from "./User.vue?vue&type=template&id=39b9da20&scoped=true&"
import script from "./User.vue?vue&type=script&lang=tsx&"
export * from "./User.vue?vue&type=script&lang=tsx&"
import style0 from "./User.vue?vue&type=style&index=0&id=39b9da20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9da20",
  null
  
)

export default component.exports